import script from "./ProductInfoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductInfoModal.vue?vue&type=script&setup=true&lang=js"

import "./ProductInfoModal.vue?vue&type=style&index=0&id=2cceadc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cceadc4"]])

export default __exports__